import {
  getOthBesluitGrondslag,
  getOthBesluitGrondslagId,
} from '@/api/generated/digiVAPI';
import { createQuery } from '@/utils/tanstack-query/createQuery';

export const useBesluitGrondslag = createQuery({
  key: ['besluitGrondslag'],
  queryFn: getOthBesluitGrondslag,
});

export const useBesluitGrondslagId = createQuery({
  key: ['besluitGrondslagId'],
  queryFn: getOthBesluitGrondslagId,
});
